import { Badge } from '../../../ui/Badge';
import { ActorName, Card } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';
import type { AttemptDetail } from '../types';

export function AdminDecisions({ a }: { a: AttemptDetail }) {
  return (
    <>
      {(a.verifications.length > 0 || a.corrections.length > 0) && (
        <Card title="Admin decisions">
          <ul className="checklist">
            {a.verifications.map((v) => (
              <li key={v.id} style={{ flexDirection: 'column', gap: 2 }}>
                <span>
                  <Badge tone="success">Verified</Badge> by <ActorName actor={v.admin} /> ·{' '}
                  <Timestamp value={v.createdAt} />
                </span>
                <span className="small">
                  {v.reason} — {v.evidence}
                </span>
              </li>
            ))}
            {a.corrections.map((c) => (
              <li key={c.id} style={{ flexDirection: 'column', gap: 2 }}>
                <span>
                  <Badge tone="warning">
                    {c.kind === 'reconciliation' ? 'Reconciliation' : 'Correction'}
                  </Badge>{' '}
                  {c.previousOutcome} → {c.correctedOutcome} by <ActorName actor={c.admin} /> ·{' '}
                  <Timestamp value={c.createdAt} />
                </span>
                <span className="small">
                  {c.reason} — {c.evidence}
                </span>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </>
  );
}
